import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';

import LanguageSelectDialog from '../../../dialogs/LanguageSelectDialog/LanguageSelectDialog';
import Language from '../../../types/Language';
import api from '../../../utils/api';
import { StyledButton, StyledFlag } from './styled';

const LanguageSelectorDrawer = () => {
    const { t } = useTranslation();

    const [languages, setLanguage] = useState<Language[]>([]);
    const [isModalOpen, setIsModalOpen] = useState(false);

    const languageCode = t('language_code');
    const languageName = t('language_description');
    const countryCode = languageCode.split('-').pop();

    useEffect(() => {
        api.request('/languages').then(res => {
            setLanguage(res);
        });
    }, []);

    return (
        <>
            <StyledButton onClick={() => setIsModalOpen(true)} variant='outlined' color='default' >
                <StyledFlag code={countryCode} style={{borderRadius: '8px'}} />
                {languageName}
            </StyledButton>
            <LanguageSelectDialog open={isModalOpen} onClose={() => setIsModalOpen(false)} languages={languages} />
        </>
    );
};

export default LanguageSelectorDrawer;
